import { IBase } from "./base";

export type DoorPayload = {
  id?: string,
  location: string
};

export class Door implements IBase {
  public id = '';
  public locker_id = '';
  public location = '';

  static payload(args: Door, isNew = false): DoorPayload {
    const payload: DoorPayload = {
      id: args.id,
      location: args.location
    };
    
    if (isNew) {
      const {id: _, ...sanitized} = payload;
      return sanitized;
    }

    return payload;
  }

  static doorsPayload(args: Array<Door>, isNew = false): Array<DoorPayload> {
    const temp = [];
    for (const locker of args) {
      temp.push(Door.payload(locker, isNew));
    }

    return temp;
  }
}
